import React, { useEffect } from "react";
import {
  makeStyles,
  DialogTitle,
  Dialog,
  DialogContent,
  DialogActions,
  Button,
} from "@material-ui/core";
import audioSound from "../../sound/sound-notification.mp3";
import { text } from '../../utils/Multilanguage';

const styles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  flex: {
    flex: 1,
  },
  imgContainer: {
    position: "relative",
    flex: 1,
    padding: 16,
    display: "grid",
    justifyContent: "center",
    alignItems: "center",
  },
  img: {
    maxWidth: "100%",
    maxHeight: "100%",
    border: "1px solid",
  },
}));

export default function DialogNotification(props) {
  const { open, onClose, cuerpo, handleOk, handleVer, onlyOkButton } = props;
  const classes = styles();
  const audio = new Audio(audioSound);

  useEffect(() => {
    if (open) {
      if (localStorage.getItem("sound") === "true") {
        audio.load();
        //audio.play();
        var playPromise = audio.play();
        if (playPromise !== undefined) {
          playPromise
            .then((_) => {
              // Automatic playback started!
              // Show playing UI.
            })
            .catch((error) => {
              console.log(error);
              // Auto-play was prevented
              // Show paused UI.
            });
        }
      }
    }
  }, [open]);

  return (
    <Dialog
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      open={open}
      onClose={onClose}
      fullWidth={true}
      maxWidth='xl'
      disableBackdropClick={true}
    >
      <DialogTitle
        id='alert-dialog-title'
        style={{ backgroundColor: "#fafafa" }}
      >
        {text("Warning")}
      </DialogTitle>
      <DialogContent>
        <div className={classes.imgContainer}>
          <h6>{cuerpo}</h6>
          <br />
        </div>
      </DialogContent>
      <DialogActions style={{ color: "white" }}>
        <Button
          variant='contained'
          style={{ background: "#fafafa" }}
          onClick={handleOk}
        >
          OK
        </Button>
        {onlyOkButton === false && (
          <Button
            variant='contained'
            onClick={handleVer}
            style={{ background: "#fafafa" }}
          >
            {localStorage.getItem("language") === "en" ? "VIEW" : "VER"}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
